module.exports = __webpack_public_path__ + "static/media/reviews.bcb6ea37.png";